// @TODO: Audit Like button

const VoteRequest = {
  thumb: null,

  new: function(uiVoteThumb){
    var voteRequest = Object.create(VoteRequest);

    if(uiVoteThumb !== undefined){
      voteRequest.thumb = uiVoteThumb;
    }

    voteRequest.bindAjaxSuccess();
    return voteRequest;
  },

  bindAjaxSuccess: function() {
    this.bindAjaxSuccessForThumbVote();
  },

  bindAjaxSuccessForThumbVote: function() {
    $(this.thumb.ui.root).on('ajax:success', this.thumb.ui.upvote + ", " + this.thumb.ui.downvote, function(event, data) {
      var klass = this.thumb.ui.upvote.replace(".", "");
      if ($(event.target).hasClass(klass)){
        this.ajaxSuccessCallbackForThumbVoteUp(event, data);
      }else{
        this.ajaxSuccessCallbackForThumbVoteDown(event, data);
      }
    }.bind(this));
  },

  ajaxSuccessCallbackForThumbVoteUp: function(event){
    this.thumb.setCurrentTarget(event.target);
    this.thumb.setCurrentTarget(null);
  },

  ajaxSuccessCallbackForThumbVoteDown: function(event){
    this.thumb.setCurrentTarget(event.target);
    this.thumb.setCurrentTarget(null);
  }
};

export default VoteRequest;
